import { render, staticRenderFns } from "./Refs.vue?vue&type=template&id=4e080326&"
import script from "./Refs.vue?vue&type=script&lang=js&"
export * from "./Refs.vue?vue&type=script&lang=js&"
import style0 from "./Refs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports